import StoreLinks from './StoreLinks';

export default StoreLinks;
